/*! Bead Yours - storefront rendering: design thumbnails, home hero animation, category galleries,
    Customer Creation buy buttons and cart thumbnails. Needs by-core.js; uses by-templates.js and
    by-jewelry.js when present. */
(function (g) {
  'use strict';
  var BY = g.BeadYours = g.BeadYours || {};
  var h = BY.h;

  // spec: "tpl:<id>", "pet:<id>", "preset:<id>", or a design code "p1...." / "j1...."
  BY.designFromSpec = function (spec) {
    spec = String(spec || '').trim();
    if (!spec) return null;
    if (spec.indexOf('code:') === 0) spec = spec.slice(5);
    if (spec.indexOf('tpl:') === 0) {
      var t = (BY.TEMPLATES || []).filter(function (x) { return x.id === spec.slice(4); })[0];
      return t ? { kind: 'perler', d: BY.templateGrid(t), name: t.name } : null;
    }
    if (spec.indexOf('pet:') === 0) {
      var p = (BY.PET_PRESETS || []).filter(function (x) { return x.id === spec.slice(4); })[0];
      return p ? { kind: 'perler', d: BY.composePet(p), name: p.name } : null;
    }
    if (spec.indexOf('preset:') === 0) {
      var pr = (BY.JEWELRY_PRESETS || []).filter(function (x) { return x.id === spec.slice(7); })[0];
      if (!pr || !BY.JEWELRY_PIECES) return null;
      var pc = BY.JEWELRY_PIECES.filter(function (x) { return x.key === pr.p; })[0];
      var sz = pc.sizes.filter(function (x) { return x[0] === pr.s; })[0];
      return { kind: 'jewelry', d: { v: 1, p: pr.p, s: pr.s, b: pr.make(Math.round(sz[2] * 25.4 / 6.2), pr.text) }, name: pr.name };
    }
    try {
      if (spec.indexOf('p1.') === 0) return { kind: 'perler', d: BY.decodePerler(spec) };
      if (spec.indexOf('j1.') === 0) return { kind: 'jewelry', d: BY.decodeJewelry(spec) };
    } catch (e) { return null; }
    return null;
  };
  BY.designCode = function (r) { return r.kind === 'perler' ? BY.encodePerler(r.d.w, r.d.h, r.d.grid) : BY.encodeJewelry(r.d); };

  // Fill an element with a picture of the design
  BY.renderInto = function (el, spec, size) {
    var r = BY.designFromSpec(spec);
    if (!r) return null;
    size = size || parseInt(el.getAttribute('data-size'), 10) || 320;
    el.innerHTML = '';
    if (r.kind === 'perler') {
      var img = new Image();
      img.alt = el.getAttribute('data-alt') || r.name || 'Bead design';
      img.decoding = 'async';
      img.src = BY.perlerThumb(r.d.w, r.d.h, r.d.grid, size, { mode: 'beads' });
      el.appendChild(img);
    } else if (BY.jewelryPreview) {
      el.innerHTML = BY.jewelryPreview(r.d, { w: 360, h: 300 });
    }
    return r;
  };

  function renderAll(root) {
    (root || document).querySelectorAll('[data-by-render]:not([data-by-done])').forEach(function (el) {
      el.setAttribute('data-by-done', '1');
      BY.renderInto(el, el.getAttribute('data-by-render'));
    });
  }

  /* ------------------------------------------------------------ hero animation */
  function hero(cv) {
    var specs = (cv.getAttribute('data-designs') || 'tpl:heart').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var caption = cv.parentNode.querySelector('[data-by-hero-caption]');
    var designs = specs.map(BY.designFromSpec).filter(function (r) { return r && r.kind === 'perler'; });
    if (!designs.length) return;
    var N = 29, ctx = cv.getContext('2d'), idx = 0, order = [], start = 0, reduce = g.matchMedia && g.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function sized() {
      var r = cv.getBoundingClientRect(), dpr = g.devicePixelRatio || 1;
      cv.width = Math.max(1, Math.round(r.width * dpr)); cv.height = Math.max(1, Math.round(r.height * dpr));
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      return r.width;
    }
    var W = sized();
    function boardFor(r) {
      var d = r.d, grid = new Uint8Array(N * N), ox = Math.floor((N - d.w) / 2), oy = Math.floor((N - d.h) / 2);
      BY.stamp(grid, N, N, d.grid, d.w, d.h, ox, oy);
      return grid;
    }
    var boards = designs.map(boardFor);
    function shuffleOrder(grid) {
      var cells = [];
      for (var i = 0; i < grid.length; i++) if (grid[i]) cells.push(i);
      // fill roughly bottom-up like hands placing beads, with jitter
      cells.sort(function (a, b) { return (Math.floor(b / N) - Math.floor(a / N)) * 3 + (Math.random() - 0.5) * 9; });
      return cells;
    }
    function frame(t) {
      if (!cv.isConnected) return;
      var cell = W / N, grid = boards[idx];
      ctx.clearRect(0, 0, W, W);
      var elapsed = t - start, dur = 1500, hold = 2600, shown;
      if (reduce) shown = order.length; else shown = Math.min(order.length, Math.floor(order.length * Math.min(1, elapsed / dur)));
      var tmp = new Uint8Array(N * N);
      for (var i = 0; i < shown; i++) tmp[order[i]] = grid[order[i]];
      BY.drawPerler(ctx, N, N, tmp, { cell: cell, mode: 'beads', pegs: true, pegColor: 'rgba(110,100,140,.22)' });
      if (!reduce && elapsed > dur + hold && designs.length > 1) next(t);
      else if (!reduce) g.requestAnimationFrame(frame);
    }
    function next(t) {
      idx = (idx + 1) % designs.length;
      order = shuffleOrder(boards[idx]); start = t || g.performance.now();
      if (caption) caption.textContent = designs[idx].name || '';
      g.requestAnimationFrame(frame);
    }
    order = shuffleOrder(boards[0]); start = g.performance.now();
    if (caption) caption.textContent = designs[0].name || '';
    g.requestAnimationFrame(frame);
    g.addEventListener('resize', function () { W = sized(); if (reduce) g.requestAnimationFrame(frame); });
  }

  /* ------------------------------------------------------------ category galleries */
  function linkFor(builder, r, name, cat) {
    return builder + '#design=' + encodeURIComponent(BY.designCode(r)) + '&name=' + encodeURIComponent(name || r.name || '') + (cat ? '&cat=' + encodeURIComponent(cat) : '');
  }
  function categoryTemplates(el) {
    var cat = el.getAttribute('data-cat'), builder = el.getAttribute('data-builder') || '/pages/perler-builder';
    var list = (BY.TEMPLATES || []).filter(function (t) { return t.cat === cat; }).map(function (t) { return 'tpl:' + t.id; });
    if (cat === 'pets') list = (BY.PET_PRESETS || []).map(function (p) { return 'pet:' + p.id; }).concat(list);
    var extra = (el.getAttribute('data-extra') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    list = extra.concat(list);
    var grid = h('div', { class: 'by-cards' });
    list.forEach(function (spec) {
      var r = BY.designFromSpec(spec); if (!r) return;
      var art = h('span', { class: 'by-card-art' });
      BY.renderInto(art, spec, 260);
      grid.appendChild(h('a', { class: 'by-card', href: linkFor(builder, r, null, cat) }, [art, h('span', { class: 'by-card-title', text: r.name }), h('span', { class: 'by-card-meta' }, [h('span', { text: 'Start with this' })])]));
    });
    el.innerHTML = '';
    if (!grid.children.length) { el.appendChild(h('p', { class: 'by-empty', text: 'Templates for this theme are on the way. Start from a blank board in the meantime.' })); return; }
    el.appendChild(grid);
  }
  function categoryPresets(el) {
    var builder = el.getAttribute('data-builder') || '/pages/jewelry-builder';
    var ids = (el.getAttribute('data-presets') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var grid = h('div', { class: 'by-cards' });
    ids.forEach(function (id) {
      var r = BY.designFromSpec('preset:' + id); if (!r) return;
      var art = h('span', { class: 'by-card-art' }); art.innerHTML = BY.jewelryPreview(r.d, { w: 360, h: 300 });
      var piece = (BY.JEWELRY_PIECES || []).filter(function (p) { return p.key === r.d.p; })[0];
      var pr = (BY.JEWELRY_PRESETS || []).filter(function (x) { return x.id === id; })[0];
      grid.appendChild(h('a', { class: 'by-card', href: linkFor(builder, r, null, pr && pr.cat) }, [art, h('span', { class: 'by-card-title', text: r.name }), h('span', { class: 'by-card-meta' }, [h('span', { text: piece ? piece.name : '' })])]));
    });
    el.innerHTML = ''; el.appendChild(grid);
  }

  /* ------------------------------------------------------------ Customer Creation buy button */
  function bindBuy(btn) {
    if (btn.__by) return; btn.__by = true;
    btn.addEventListener('click', function () {
      var code = btn.getAttribute('data-code'), name = btn.getAttribute('data-name') || 'Customer Creation';
      var id = parseInt(btn.getAttribute('data-variant'), 10);
      if (!id) return;
      var props = { 'Design': name, 'Customer Creation': 'Yes' };
      if (code) { props._design = code; props._pattern = BY.patternUrl({ patternUrl: btn.getAttribute('data-pattern-url') }, code); }
      btn.disabled = true; var label = btn.textContent; btn.textContent = 'Adding...';
      BY.cartAdd([{ id: id, quantity: 1, properties: props }]).then(function () {
        g.location.href = BY.root() + 'cart';
      }).catch(function (e) { BY.toast(e.message || 'Could not add to cart', 'error'); btn.disabled = false; btn.textContent = label; });
    });
  }

  /* ------------------------------------------------------------ cart thumbnails */
  function cartThumbs(root) {
    (root || document).querySelectorAll('.by-cart-thumb[data-by-design]:not([data-by-done])').forEach(function (el) {
      el.setAttribute('data-by-done', '1');
      BY.renderInto(el, el.getAttribute('data-by-design'), 200);
    });
  }

  function boot() {
    renderAll();
    document.querySelectorAll('canvas[data-by-hero-canvas]').forEach(function (cv) { if (!cv.__by) { cv.__by = 1; hero(cv); } });
    document.querySelectorAll('[data-by-category-templates]').forEach(categoryTemplates);
    document.querySelectorAll('[data-by-category-presets]').forEach(categoryPresets);
    document.querySelectorAll('[data-by-buy]').forEach(bindBuy);
    cartThumbs();
    if (g.MutationObserver && !BY._renderObs) {
      BY._renderObs = new MutationObserver(function () { cartThumbs(); renderAll(); });
      BY._renderObs.observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'complete') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})(window);
